import type { RosterPlayer } from './db.js';

const baseName = (player: RosterPlayer): string => player.preferredName ?? player.firstName;
const key = (text: string): string => text.trim().toLocaleLowerCase();

export function playerLabel(player: RosterPlayer, roster: readonly RosterPlayer[]): string {
  const name = baseName(player);
  const peers = roster.filter(
    (other) => key(baseName(other)) === key(name) && other.jerseyNumber === player.jerseyNumber,
  );
  if (peers.length < 2 || !player.lastName?.trim()) return name;
  const last = player.lastName.trim();
  const initial = last.charAt(0);
  const sameInitial = peers.filter(
    (other) => key(other.lastName?.trim().charAt(0) ?? '') === key(initial),
  );
  return `${name} ${sameInitial.length > 1 ? last : `${initial}.`}`;
}

export function spokenPlayerLabel(player: RosterPlayer, roster: readonly RosterPlayer[]): string {
  const name = playerLabel(player, roster);
  return player.jerseyNumber == null ? name : `${String(player.jerseyNumber)} ${name}`;
}
